import { styled } from "@mui/material/styles";

// Components
import { Box, Modal, Typography } from "@mui/material";
import { StyledCard, theme } from "~/components/Common";

const styledName = "WalletInfo";

export const StyledInfoWrapper = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    width: "fit-content",
    flexDirection: "column",
  },
});

export const StyledInfoLabel = styled(Typography, { name: styledName })({
  "&": {
    fontSize: "2rem",
    fontWeight: 500,
    width: "100%",
    textAlign: "start",
    marginBottom: "20px",
  },
});

export const StyledInfoContent = styled(StyledCard, { name: styledName })({
  "&": {
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "all 3s ease-in",
    minWidth: "420px",
    position: "relative",
    overflow: "visible",
  },
});

export const StyledInfoAction = styled(Box, { name: styledName })({
  "&": {
    height: "30px",
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
  },
});

export const StyledInfoDetail = styled(Box, { name: styledName })({
  "&": {
    padding: "30px 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
});

export const StyledItemText = styled(Typography, { name: styledName })({
  "&": {
    textAlign: "start",
    fontSize: "1.6rem",
    fontWeight: "400",
  },
});

export const StyledItemCurrency = styled(Typography, { name: styledName })({
  "&": {
    textAlign: "start",
    fontSize: "2rem",
    fontWeight: "400",
    color: theme.palette.primary.main,
  },
});

export const StyledDeleteButton = styled("div", { name: styledName })({
  "&": {
    width: "fit-content",
  },
});

export const StyledModal = styled(Modal, { name: styledName })({
  "&": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
